module.exports = __webpack_public_path__ + "img/介绍顶部图.d93a67db.jpg";